export const DpRewardsTrophy = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="10.927"
		height="10.927"
		viewBox="0 0 10.927 10.927"
	>
		<defs>
			<clipPath id="clip-path">
				<rect
					id="Rectángulo_5243"
					data-name="Rectángulo 5243"
					width="5.507"
					height="5.517"
					fill="#fbfbfb"
				/>
			</clipPath>
		</defs>
		<g id="Grupo_1558" data-name="Grupo 1558" transform="translate(-7643.708 -8185.289)">
			<path
				id="iconmonstr-star-6"
				d="M5.464,0a5.464,5.464,0,1,0,5.464,5.464A5.464,5.464,0,0,0,5.464,0Z"
				transform="translate(7643.708 8185.289)"
				fill="#333"
			/>
			<g id="Grupo_1527" data-name="Grupo 1527" transform="translate(7646.417 8187.993)">
				<g id="Grupo_1526" data-name="Grupo 1526" clip-path="url(#clip-path)">
					<path
						id="Trazado_892"
						data-name="Trazado 892"
						d="M4.4,5.517H1.108a.111.111,0,0,1,0-.026c.073-.212.144-.424.222-.634a.329.329,0,0,1,.1-.119.306.306,0,0,1,.22-.05H2.2l.189-.57a1.689,1.689,0,0,1-1.3-1.662l-.035-.009A1.247,1.247,0,0,1,0,1.194Q0,.887,0,.58a.265.265,0,0,1,.3-.3H1.1V0H4.409V.277H5.2a.511.511,0,0,1,.112.01A.261.261,0,0,1,5.506.5v.83a.451.451,0,0,0-.01.046A1.248,1.248,0,0,1,4.474,2.443c-.059.009-.069.031-.071.084A1.653,1.653,0,0,1,3.321,4.048c-.066.025-.135.043-.208.066l.191.574h.62a.266.266,0,0,1,.26.188c.052.152.106.3.158.457.021.061.038.122.057.184M1.928,1.656c.134.179.258.346.384.511a.09.09,0,0,1,.017.089c-.018.06-.031.121-.047.182L2.2,2.757l.062-.032c.151-.083.3-.165.451-.249a.065.065,0,0,1,.073,0c.153.086.307.17.461.254l.052.026c-.043-.172-.083-.336-.125-.5a.092.092,0,0,1,.017-.089c.109-.142.216-.286.323-.43l.059-.081H3.508c-.154,0-.308,0-.462,0a.059.059,0,0,1-.064-.042c-.065-.149-.133-.3-.2-.447-.008-.017-.017-.034-.029-.058-.012.024-.022.041-.029.058-.067.149-.134.3-.2.447a.059.059,0,0,1-.064.042c-.1,0-.208,0-.312,0H1.928M4.409.831V1.9c.023-.005.042-.008.06-.014a.672.672,0,0,0,.443-.443,1.176,1.176,0,0,0,.043-.3c.007-.1,0-.21,0-.318ZM.55.831c0,.126,0,.245,0,.365a.7.7,0,0,0,.238.533A.714.714,0,0,0,1.1,1.9V.831Z"
						transform="translate(0)"
						fill="#fbfbfb"
					/>
				</g>
				<rect
					id="Rectángulo_5273"
					data-name="Rectángulo 5273"
					width="2.3"
					height="2.3"
					transform="translate(1.532 0.92)"
					fill="#fbfbfb"
				/>
			</g>
		</g>
	</svg>
);
